export const zhHK = {
  openPhoto: '開啟照片',
  title: '選擇照片',
  cancel: '取消',
  takePhoto: '拍攝照片',
  chooseFromLibrary: '從相簿中選擇',
}
